// 胡牌儀式的純版面規則，供 Phaser 畫面與測試共用。
//
// === 使用圖片 ===
// 無 — 純座標資料，不直接渲染畫面。

import type { TSeat } from '@core/types';

export interface IChuckerTileOffset {
  readonly x: number;
  readonly y: number;
}

const CHUCKER_TILE_OFFSET_BY_SEAT: Readonly<Record<TSeat, IChuckerTileOffset>> = {
  0: { x: 130, y: 0 }, // 本家：放槍牌在圖示右方
  1: { x: 0, y: -120 }, // 右家：放槍牌在圖示上方
  2: { x: 130, y: 0 }, // 對家：放槍牌在圖示右方
  3: { x: 0, y: -120 }, // 左家：放槍牌在圖示上方
};

export const chuckerTileOffsetOf = (seat: TSeat): IChuckerTileOffset =>
  CHUCKER_TILE_OFFSET_BY_SEAT[seat];
